import { featuredProducts } from "@/data/products";

export const HERO_IMAGE = "/products/nad.webp";

export const BENEFITS_IMAGE = "/why-we-exist.jpg";

export const LOGO_IMAGES = ["/logo-dark.png", "/logo-light.png", "/logo-footer.png"];

export const LANDING_IMAGES = [
  HERO_IMAGE,
  BENEFITS_IMAGE,
  ...LOGO_IMAGES,
  ...featuredProducts.map((p) => p.image),
];

const cache = new Set();

export function preloadImages(urls = []) {
  urls.forEach((src) => {
    if (!src || cache.has(src)) return;
    cache.add(src);
    const img = new Image();
    img.decoding = "async";
    img.src = src;
  });
}

export function preloadLandingImages() {
  preloadImages(LANDING_IMAGES);
}
